module.exports = __webpack_public_path__ + "images/logos/logo-supergoop-bd57dc41bbf37df99f65414dbf4dcede.webp";